var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25148 1.2197C3.62585 0.414815 5.38556 0.880493 6.18192 2.25982L7.88954 5.21751L9.59717 8.17521C10.3935 9.55453 9.92495 11.3252 8.55058 12.1301C7.17622 12.9349 5.4165 12.4693 4.62014 11.0899L2.91252 8.13225L1.20489 5.17455C0.40854 3.79523 0.877112 2.02458 2.25148 1.2197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88954 5.21751L6.18192 2.25982C5.38556 0.880493 3.62585 0.414815 2.25148 1.2197V1.2197C0.877112 2.02458 0.408539 3.79523 1.20489 5.17455L2.91252 8.13225M7.88954 5.21751L9.59717 8.17521C10.3935 9.55453 9.92495 11.3252 8.55058 12.1301V12.1301C7.17622 12.9349 5.4165 12.4693 4.62014 11.0899L2.91252 8.13225M7.88954 5.21751L2.91252 8.13225",
    stroke: "#2B7FD7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4368 14.7949C6.05007 14 5.57727 12.2354 6.38076 10.8537L8.08106 7.92964L9.78136 5.00562C10.5849 3.62384 12.3604 3.1481 13.7471 3.94303C15.1338 4.73795 15.6066 6.50252 14.8032 7.8843L13.1029 10.8083L11.4026 13.7323C10.5991 15.1141 8.82353 15.5899 7.4368 14.7949Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78137 5.00567L9.43386 5.60329C8.63037 6.98507 9.10317 8.74964 10.4899 9.54456C11.8766 10.3395 13.6522 9.86374 14.4557 8.48196L14.8032 7.88435C15.6067 6.50257 15.1339 4.738 13.7471 3.94308C12.3604 3.14815 10.5849 3.62389 9.78137 5.00567Z",
    fill: "#2B7FD7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08106 7.92964L6.38076 10.8537C5.57727 12.2354 6.05007 14 7.4368 14.7949V14.7949C8.82353 15.5899 10.5991 15.1141 11.4026 13.7323L13.1029 10.8083M8.08106 7.92964L9.78136 5.00562C10.5849 3.62384 12.3604 3.1481 13.7471 3.94303V3.94303C15.1338 4.73795 15.6066 6.50252 14.8032 7.8843L13.1029 10.8083M8.08106 7.92964L13.1029 10.8083",
    stroke: "#2B7FD7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPills);
export default __webpack_public_path__ + "static/media/notificationPills.54e0221074991747abe754a608d5d0e0.svg";
export { ForwardRef as ReactComponent };